function initSlumberSliderWheelPassthrough(root = document) {
  const trackSelector = [
    '.slumber-collection-slider__track',
    '.slumber-category-slider__track',
    '.slumber-reviews__track',
  ].join(',');
  const isCoarsePointer =
    typeof window.matchMedia === 'function' && window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  root.querySelectorAll(trackSelector).forEach((track) => {
    if (track.dataset.slumberWheelBound) return;
    track.dataset.slumberWheelBound = 'true';

    // Desktop: vertical mouse-wheel should scroll the page, not nudge the track.
    track.addEventListener(
      'wheel',
      (event) => {
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

        const canScrollHorizontally = track.scrollWidth > track.clientWidth + 1;
        if (!canScrollHorizontally) return;

        event.preventDefault();
        window.scrollBy({ top: event.deltaY, left: 0, behavior: 'auto' });
      },
      { passive: false }
    );

    // Mobile collection slider uses touch-action: pan-y (native page scroll).
    // Skip custom touch hijacking there to avoid scroll jerks.
    if (isCoarsePointer && track.classList.contains('slumber-collection-slider__track')) {
      return;
    }

    // Other mobile sliders: vertical swipe should scroll the page, not rubber-band the track.
    let startX = 0;
    let startY = 0;
    let lastY = 0;
    let axis = null;
    let previousOverflowX = '';
    let previousSnap = '';

    const unlockVertical = () => {
      if (axis === 'y') {
        track.style.overflowX = previousOverflowX;
        track.style.scrollSnapType = previousSnap;
        track.classList.remove('slumber-slider-track--page-scroll');
      }
      axis = null;
    };

    track.addEventListener(
      'touchstart',
      (event) => {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        lastY = startY;
        axis = null;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      (event) => {
        if (event.touches.length !== 1) return;

        const touchY = event.touches[0].clientY;
        const touchX = event.touches[0].clientX;

        if (axis === null) {
          const dx = Math.abs(touchX - startX);
          const dy = Math.abs(touchY - startY);

          if (dx < 8 && dy < 8) return;

          axis = dy > dx ? 'y' : 'x';

          if (axis === 'y') {
            previousOverflowX = track.style.overflowX;
            previousSnap = track.style.scrollSnapType;
            track.style.overflowX = 'hidden';
            track.style.scrollSnapType = 'none';
            track.classList.add('slumber-slider-track--page-scroll');
          }
        }

        if (axis === 'y') {
          event.preventDefault();
          window.scrollBy({ top: lastY - touchY, left: 0, behavior: 'auto' });
          lastY = touchY;
        }
      },
      { passive: false }
    );

    track.addEventListener('touchend', unlockVertical, { passive: true });
    track.addEventListener('touchcancel', unlockVertical, { passive: true });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initSlumberSliderWheelPassthrough());
} else {
  initSlumberSliderWheelPassthrough();
}

document.addEventListener('shopify:section:load', (event) => {
  initSlumberSliderWheelPassthrough(event.target);
});
